// Transform 12:00:00 to 12:00p
export const timeConvert24toAMPM = (time) => {
  if (!time || !time.includes(':')) {
    return time;
  }

  if (time.includes('AM') || time.includes('PM')) {
    return timeConvertUpperToLower(time);
  }

  const splitTime = time.includes(':') ? time.split(':') : [-1, -1];
  const hour = Number(splitTime[0]);

  if (hour > 12) {
    return hour - 12 + ':' + splitTime[1] + 'p';
  }
  return hour + ':' + splitTime[1] + (hour === 12 ? 'p' : 'a');
};

// Transform 12:00 PM to 12:00p or 04:00 AM to 4:00a
export const timeConvertUpperToLower = (time) => {
  if (!time && typeof time !== 'string') {
    return time;
  }

  return time.replace('M', '').replace(' ', '').toLowerCase();
};

// Transform { milliseconds , secondsd, minutes, hours, days, months, years } to HH MM
export const timeConvertObjectToDuration = (time) => {
  if (!time) {
    return ' ';
  }
  const hours = time.days * 24 + time.hours;
  return hours + 'h ' + time.minutes + 'm';
};

export const getTotalDuration = (totalDuration) => {
  let hour = 0;
  let min = 0;
  hour = parseInt(hour) + parseInt(Math.floor(totalDuration / 60));
  min = parseInt(min) + parseInt(Math.floor(totalDuration % 60));
  if (min >= 60) {
    hour += parseInt(Math.floor(min / 60));
  }
  const duration = hour + 'h ' + min.toString().padStart(2, '0') + 'm';
  return duration;
};
export const getLayoverTime = (layover, arrAirportName) => {
  let layoverStr = '';
  if (Math.floor(layover / 60) != 0) {
    if (layover % 60 != 0) {
      layoverStr =
        'Layover: ' + Math.floor(layover / 60) + ' h ' + (layover % 60) + ' m in ' + arrAirportName;
    } else {
      layoverStr = 'Layover: ' + Math.floor(layover / 60) + ' h  in ' + arrAirportName;
    }
  } else {
    layoverStr = 'Layover: ' + (layover % 60) + ' m in ' + arrAirportName;
  }
  return layoverStr;
};
